import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var PolygonIcon = function PolygonIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "PolygonIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3.391 2.556a.835.835 0 1 0 0 1.67.835.835 0 0 0 0-1.67M1 3.39a2.39 2.39 0 0 1 4.653-.778h4.695a2.392 2.392 0 1 1 2.594 3.146L11.662 8l1.28 2.241a2.391 2.391 0 1 1-2.594 3.146H5.653a2.392 2.392 0 1 1-3.04-3.04V5.654A2.39 2.39 0 0 1 1 3.39m3.169 2.262v4.695a2.4 2.4 0 0 1 1.484 1.483h4.695c.18-.522.535-.963.996-1.251L10.22 8.615a1.24 1.24 0 0 1 0-1.23l1.123-1.965a2.4 2.4 0 0 1-.996-1.251H5.653a2.4 2.4 0 0 1-1.484 1.484m8.44-3.097a.835.835 0 1 0 0 1.67.835.835 0 0 0 0-1.67m-9.218 9.218a.835.835 0 1 0 0 1.67.835.835 0 0 0 0-1.67m9.218 0a.835.835 0 1 0 0 1.67.835.835 0 0 0 0-1.67",
      clipRule: "evenodd"
    })
  }));
};

export { PolygonIcon };
